
import Vue, { PropType } from 'vue';
import { VFairPavilion } from '~/services/types/vfair';

// Assets
import DefaultBackground from '~/assets/img/vcf/pavilion_default.png';

export default Vue.extend({
    name: 'PavilionButton',
    props: {
        pavilion: {
            type: Object as PropType<VFairPavilion>,
            required: true,
            default: () => ({} as VFairPavilion),
        },
    },
    computed: {
        backgroundImageUrl(): string {
            return !!this.pavilion.image ? this.pavilion.image : DefaultBackground;
        },
    },
    methods: {
        goToPavilion() {
            this.$emit('click');
        },
    },
});
